import axios from "@/axios";

const endpoint = `/organization`;

const Organization = {
    verifyAccessCode: async (payload) => {
        return axios
        .post(`${endpoint}/onboard`, payload)
        .then(({ accessCode }) => {
            return {
                accessCode: accessCode
            }
        })
        .catch((error) => {
            console.log(error); 
            return null
        })
    }
}

export default Organization;